export class MainAppComponent implements ng.IComponentOptions {
    public controller: any = MainController;
    public template: string = `
        <header ng-hide="$ctrl.home" navigation="$ctrl.showNav"></header>
        <ui-view></ui-view>
        <footer></footer>`;
}

export class MainController {
  public static $inject: Array<string> = ['$location', "$rootScope"];
  public home: boolean;
  public showNav: boolean;
  constructor(private $location: ng.ILocationService, private $rootScope:ng.IRootScopeService) {
    $rootScope.$on("$stateChangeStart", (evt, toState, toParams, fromState, fromParams) => {
      if(toState.name === "home")
        this.home = true;
      else
        this.home = false;
      if(["migration"].indexOf(toState.name) > -1) {
        this.showNav = false
      }
      else {
        this.showNav = true
      }
    })
  }
}
